import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import AboutSolyraSection from '@/components/AboutSolyraSection';
import Footer from '@/components/Footer';
import HowItWorks from '@/components/HowItWorks';
import PricingSection from '@/components/PricingSection';
import WhyChoose from '@/components/WhyChoose';
import FinalCTA from '@/components/FinalCTA';
import { prefetchCalculator, prefetchContact, prefetchServicii } from '@/lib/prefetch';

const Index: React.FC = () => {
  useEffect(() => {
    // Idle-prefetch primary nav routes so navigation feels instant
    const w = window as any;
    const cb = () => { prefetchCalculator(); prefetchContact(); prefetchServicii(); };
    if (typeof w.requestIdleCallback === 'function') {
      w.requestIdleCallback(cb, { timeout: 2000 });
    } else {
      window.setTimeout(cb, 1500);
    }
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Solyra – Panouri fotovoltaice & solare pentru casa ta | Analiză gratuită</title>
        <meta name="description" content="Vezi în 2 minute dacă panourile fotovoltaice (solare) merită pentru casa ta. Analiză gratuită, instalatori autorizați ANRE, ofertă personalizată în 48h." />
        <meta name="keywords" content="panouri fotovoltaice, panouri solare, sistem fotovoltaic, calculator fotovoltaic, instalatori autorizati ANRE, solyra romania" />
        <meta property="og:title" content="Solyra – Panouri fotovoltaice & solare pentru casa ta" />
        <meta property="og:description" content="Vezi în 2 minute dacă panourile fotovoltaice merită pentru casa ta. Analiză gratuită + ofertă personalizată în 48h." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://solyra.ro/" />
        <meta property="og:image" content="https://solyra.ro/images/hero-solyra-fotovoltaice.webp" />
        <meta property="og:locale" content="ro_RO" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Solyra – Panouri fotovoltaice & solare pentru casa ta" />
        <meta name="twitter:description" content="Analiză gratuită + ofertă în 48h pentru panouri fotovoltaice (solare). Instalatori autorizați ANRE." />
        <meta name="twitter:image" content="https://solyra.ro/images/hero-solyra-fotovoltaice.webp" />
        <link rel="canonical" href="https://solyra.ro/" />
      </Helmet>
      <Navbar />
      <main className="flex-1">
        <Hero />
        <AboutSolyraSection />
        <HowItWorks />
        <PricingSection />
        <WhyChoose />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
